import React, { FC, ReactElement } from "react";
import { css, StyleDeclaration, StyleSheet } from "aphrodite";
import {
  deprecatedColors,
  deprecatedTones,
} from "@src/deprecatedDesignSystem/styles/deprecatedColors";
import Button from "@src/deprecatedDesignSystem/components/Button";

type EmptyStateButtonProps = {
  copy: string;
  onClick: () => void;
};

type EmptyStateProps = {
  description: string;
  textBold?: string;
  button?: EmptyStateButtonProps;
  imgPath?: string;
  className?: StyleDeclaration;
  imgClassName?: StyleDeclaration;
  buttonComponent?: ReactElement;
};

export const EmptyState: FC<EmptyStateProps> = ({
  description,
  button,
  imgPath,
  className,
  imgClassName,
  textBold,
  buttonComponent,
}) => {
  return (
    <div className={css(styles.emptyStateContainer, className)}>
      <div className={css(styles.emptyStateInner)}>
        <img
          className={css(styles.emptyImg, imgClassName)}
          src={imgPath || "/images/head-in-mailbox.png"}
          alt="empty-state"
        />
        {textBold && <div className={css(styles.textBold)}>{textBold}</div>}
        <div className={css(styles.description)}>{description}</div>
        {buttonComponent}
        {button && <Button onClick={button.onClick} text={button.copy} />}
      </div>
    </div>
  );
};
export default EmptyState;

const styles = StyleSheet.create({
  emptyStateContainer: {
    width: "100%",
    height: 200,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 8,
  },
  emptyStateInner: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  textBold: {
    fontSize: 14,
    color: deprecatedTones.gray11,
    lineHeight: "24px",
    fontWeight: 600,
    marginBottom: 4,
    maxWidth: 300,
    textAlign: "center",
  },
  description: {
    fontSize: 14,
    color: deprecatedColors.outline,
    lineHeight: "24px",
    marginBottom: 12,
    maxWidth: 300,
    textAlign: "center",
  },
  emptyImg: {
    maxWidth: 125,
    marginBottom: 24,
    overflow: "hidden",
  },
});
